import { _deserializable } from '../_deserializable';

export class BaseResponse extends _deserializable {

  public messages: string[];
  public status: string;

}
